import React from "react";
import Icon from "../icon/icon";
import "./page-header.css";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  backButtonText?: string;
  onBackClick?: () => void;
  actionButton?: {
    text: string;
    icon?: string;
    onClick: () => void;
    variant?: "primary" | "secondary";
  };
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  showBackButton = false,
  backButtonText = "Назад",
  onBackClick,
  actionButton,
  children,
}) => {
  return (
    <div className="page-header">
      <div className="page-header__content">
        <div className="page-header__left">
          {showBackButton && (
            <button className="page-header__back-btn" onClick={onBackClick}>
              <Icon name="left" size="small" />
              {backButtonText}
            </button>
          )}
          <div className="page-header__title-section">
            <h1 className="page-header__title">{title}</h1>
            {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
          </div>
        </div>

        <div className="page-header__right">
          {actionButton && (
            <button
              className={`page-header__action-btn ${
                actionButton.variant === "secondary"
                  ? "page-header__action-btn--secondary"
                  : "page-header__action-btn--primary"
              }`}
              onClick={actionButton.onClick}
            >
              {actionButton.icon && (
                <Icon name={actionButton.icon} size="small" />
              )}
              {actionButton.text}
            </button>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
